import { Box, Button, Heading, Link, Stack, Text } from '@chakra-ui/react';
import { FC } from 'react';

type CustomBoxProps = {
  heading: string;
  body: string;
};

const CustomBox: FC<CustomBoxProps> = ({ heading, body }) => {
  return (
    <Box p={10} borderRadius='xl' bg='gray.700' textAlign='center'>
      <Heading size='md' mb={6}>
        {heading}
      </Heading>
      <Text color='gray.200'>{body}</Text>
    </Box>
  );
};

type Props = {
  nextStep: () => void;
};

const Introduction: FC<Props> = ({ nextStep }) => {
  return (
    <>
      <Stack direction={['column', null, 'row']} spacing={6} mb={8}>
        <CustomBox
          heading='SELF-CUSTODY'
          body='Crucible is a smart contract that lets users participate in reward programs using Proof of Stake. Users can keep control of their staked tokens while participating in a program.'
        />
        <CustomBox
          heading='SECURE'
          body='As users maintain control of their staked tokens, users funds are not pooled at a single point of failure, proving to be a safer and more accepted solution to participants.'
        />
        <CustomBox
          heading='CAPITAL EFFICIENT'
          body='You can run multiple reward programs using the same staking token, allowing users to re-use the same staking balance which in turn adds an additional lock to the balance'
        />
      </Stack>
      <Heading size='md' mb={6}>
        Requirements
      </Heading>
      <Text color='gray.200'>
        Before starting, please spend a few minutes to familiarise yourself with{' '}
        <Link
          as={Link}
          href='https://docs.crucible.wtf/launching-a-reward-program/getting-started'
          isExternal
        >
          <u>our reward program documentation</u>
        </Link>
        .
      </Text>
      <Text color='gray.200' mt={5}>
        Launching a reward program is permissionless and is done via our
        factory. We welcome all protocols to launch a reward program via
        Crucible; giving you instant access to a vast, already existing
        community.
      </Text>
      <Text color='gray.200' mt={5}>
        <strong>
          Programs that appear to be made in bad faith will be delisted.
        </strong>
      </Text>
      <Text color='gray.200' mt={5}>
        Programs that are deployed by new/unrecognised wallets will be
        automatically classified as Unverified. Please reach out to us on{' '}
        <Link as={Link} href='https://discord.alchemist.wtf' isExternal>
          Discord
        </Link>{' '}
        if you wish to become a verified reward program maintainer.
      </Text>
      <Text color='gray.200' mt={5}>
        <strong>Token pricing data</strong> is retrieved from Coingecko & Fjord
        LBPs (historical pricing). Uniswap V2 & Balancer Pool Tokens are
        supported for automatic valuation (if underlying tokens are on
        coingecko), other pools such as AAVE can be supported by request. If
        your tokens are not being priced please ensure it is listed on Coingecko
        before contacting us.
      </Text>
      <Text color='red.300' mt={5}>
        This service and product is provided with no warranty or guarantee. All
        contracts are unaudited. Please proceed at your own risk.
      </Text>
      <Box textAlign='end' mt={10}>
        <Button onClick={() => nextStep()}>Proceed</Button>
      </Box>
    </>
  );
};

export default Introduction;
